import { render, staticRenderFns } from "./ProjectFilesPage.vue?vue&type=template&id=30386450&scoped=true&lang=pug&"
import script from "./ProjectFilesPage.vue?vue&type=script&lang=js&"
export * from "./ProjectFilesPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFilesPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectFilesPage.vue?vue&type=style&index=1&id=30386450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30386450",
  null
  
)

export default component.exports